export const GEO_GRANTED_KEY = "inssa:geo:granted";

function resolveStorage(storage) {
  if (storage) return storage;
  if (typeof localStorage === "undefined") return null;
  return localStorage;
}

export function hasCachedGeoGrant(storage) {
  try {
    return resolveStorage(storage)?.getItem(GEO_GRANTED_KEY) === "1";
  } catch {
    return false;
  }
}

export function rememberGeoGrant(storage) {
  try {
    resolveStorage(storage)?.setItem(GEO_GRANTED_KEY, "1");
  } catch {}
}

export function clearCachedGeoGrant(storage) {
  try {
    resolveStorage(storage)?.removeItem(GEO_GRANTED_KEY);
  } catch {}
}
